import Vue from 'vue'
import App from './App.vue'

import firebase from 'firebase';
import router from './router.js'
import i18n from './i18n.js'

const moment = require('moment');
//require('moment/locale/uk');
Vue.use(require('vue-moment'), {moment});

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

import './main.scss';

Vue.config.productionTip = false

let app = '';
var firebaseConfig = {
  apiKey: "AIzaSyC_BS4H5NKpD6-btYaY2jj2AsQD-Ss1gwU",
  authDomain: "vidpush-1ed7e.firebaseapp.com",
  databaseURL: "https://vidpush-1ed7e.firebaseio.com",
  projectId: "vidpush-1ed7e",
  storageBucket: "vidpush-1ed7e.appspot.com",
  messagingSenderId: "361761497468",
  appId: "1:361761497468:web:b03a68861615267a4384f9"
};
firebase.initializeApp(firebaseConfig);

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    new Vue({
      router,
      i18n,
      render: h => h(App),
    }).$mount('#app')
  }
})